import { Children } from 'react';
import { jsx } from 'react/jsx-runtime';

const NavigationOptionList = ({
  children
}) => {
  return /*#__PURE__*/jsx("ul", {
    className: "np-navigation-options-list",
    children: Children.map(children, child => /*#__PURE__*/jsx("li", {
      className: "np-navigation-options-list__item",
      children: child
    }, child?.toString()))
  });
};

export { NavigationOptionList as default };
//# sourceMappingURL=NavigationOptionsList.mjs.map
